import React from "react";
import Icon from "components/AppIcon";

const activities = [
  { id: 1, type: "order", icon: "ShoppingCart", color: "#DC2626", title: "New order placed", desc: "SM Makati — ₱48,500 order submitted by Juan dela Cruz", time: "5 min ago" },
  { id: 2, type: "alert", icon: "AlertTriangle", color: "#D4AF37", title: "Low stock alert", desc: "Shampoo 400ml below reorder threshold in Visayas", time: "18 min ago" },
  { id: 3, type: "account", icon: "UserPlus", color: "#22C55E", title: "New account registered", desc: "FamilyMart Batangas added by Ben Torres", time: "42 min ago" },
  { id: 4, type: "ai", icon: "BrainCircuit", color: "#DC2626", title: "AI insight generated", desc: "Luzon North shows 14% untapped potential in Body Wash & Lotion", time: "1 hr ago" },
  { id: 5, type: "order", icon: "CheckCircle", color: "#22C55E", title: "Order fulfilled", desc: "Puregold QC — Order #ORD-2847 delivered & confirmed", time: "2 hrs ago" },
  { id: 6, type: "alert", icon: "TrendingDown", color: "#EF4444", title: "Performance alert", desc: "Toothpaste SKU-TP01 is 7.2% below MTD target in Bulacan", time: "3 hrs ago" },
];

export default function RecentActivityFeed() {
  return (
    <div className="card p-4 md:p-6 table-panel-depth">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading text-lg md:text-xl font-semibold" style={{ color: '#0F172A', letterSpacing: '0.01em' }}>Recent Activity</h3>
          <p className="font-caption text-sm mt-0.5" style={{ color: '#475569' }}>Live feed — all territories</p>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
          <span className="font-caption text-xs text-emerald-600 font-semibold">Live</span>
        </div>
      </div>
      <div className="space-y-3">
        {activities?.map((act) => (
          <div key={act?.id} className="flex items-start gap-3 p-2.5 rounded-lg hover:bg-muted transition-colors">
            <div
              className="flex items-center justify-center w-8 h-8 rounded-full flex-shrink-0 mt-0.5"
              style={{ backgroundColor: `${act?.color}18` }}
            >
              <Icon name={act?.icon} size={15} color={act?.color} strokeWidth={2} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-caption text-sm font-semibold" style={{ color: '#1E293B' }}>{act?.title}</p>
              <p className="font-caption text-sm mt-0.5 line-clamp-2" style={{ color: '#475569' }}>{act?.desc}</p>
            </div>
            <span className="font-caption text-xs whitespace-nowrap flex-shrink-0" style={{ color: '#94A3B8' }}>{act?.time}</span>
          </div>
        ))}
      </div>
    </div>
  );
}